import { CHART_OPTIONS_META_DATA } from "../../const";
import { ETypes } from "../../types";

export const ATTRIBUTES_WITH_PERCENTAGE_POINTS = [
    CHART_OPTIONS_META_DATA[ETypes.Loyalty].xAxis.attribute,
    CHART_OPTIONS_META_DATA[ETypes.Loyalty].yAxis.attribute,
    CHART_OPTIONS_META_DATA[ETypes.AudienceGrowth].yAxis.attribute,
    CHART_OPTIONS_META_DATA[ETypes.CostEfficiency].xAxis.attribute,
    CHART_OPTIONS_META_DATA[ETypes.ConversionRate].yAxis.attribute,
];
